<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h5 class="mb-3">Search</h5>
                <div class="row">
                    <div class="col">
                        <select2 :options="clientCdOptions" v-model="params.clientCd" :label="'Client Code'"/>
                        <select2 :options="searchTypeOptions" v-model="params.searchType" :label="'Search Type'"/>
                    </div>
                    <div class="col">
                        <select2 :options="categoryOptions" v-model="params.cateCd" :label="'Category'"/>
                        <input-search :label="'Search Text'" v-model="params.searchText" @search="search"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="card block-target">
            <div class="card-header header-elements-inline pt-2 pb-2">
                <h5 class="card-title"/>
                <div class="header-elements w-100">
                    <div class="list-icons">
                        <paging :page-info="pageInfo" @search="search"  v-if="pageInfo.pages.length > 0"/>
                    </div>
                    <div class="ml-2 list-icons">
                        <select2   style="width: 150px" :options="eventListOrderOptions" v-model="params.order" :default-option="false"/>
                    </div>
                    <div class="ml-2 icon-sort-alpha-asc cursor-pointer btn" style="border-color: #ddd" v-if="params.sort === 'asc'" @click="changeSort('desc')"></div>
                    <div class="ml-2 icon-sort-alpha-desc cursor-pointer btn" style="border-color: #ddd" v-else @click="changeSort('asc')"></div>
                    <div class="list-icons mr-2  ml-auto">
                        <button class="btn btn-ums" data-toggle="modal" :data-target="'#'+eventTypeModal" v-if="hasRole($const.ROLES.EVENT_SAVE)" @click="setEventModalOptions">Create</button>
                    </div>
                    <div class="list-icons">
                        <block-target ref="blockTarget" @search="search" :class="'list-icons-item'"/>
                    </div>
                </div>
            </div>
            <basic-table :fields="tableFields" name="templateList" :list="events" class="hover-table">
                <template v-slot:icons="slotData">
                    <div style="display: flex">
                        <div style="display: flex">
                            <div data-toggle="modal" :data-target="'#'+bulkSendModal" @click="eventInfo = slotData.data" v-if="hasRole($const.ROLES.EVENT_BULK_SEND)">
                                <button class="option-icon-padding btn">
                                    <i class="icon-paperplane icon-1x"/>
                                </button>
                            </div>
                            <div data-toggle="modal" :data-target="'#'+eventTypeModal" @click="setEventModalOptions(slotData.data)" v-if="hasRole($const.ROLES.EVENT_SAVE)">
                                <button class="option-icon-padding btn">
                                    <i class="icon-pencil3 icon-1x"/>
                                </button>
                            </div>
                            <button class="option-icon-padding btn" @click="deleteEvent(slotData.data)" v-if="hasRole($const.ROLES.EVENT_DELETE)">
                                <i class="icon-trash icon-1x"/>
                            </button>
                          <div data-toggle="modal" :data-target="`#${copyEventModal}`" @click="setEventModalOptions(slotData.data, true)" v-if="hasRole($const.ROLES.EVENT_SAVE)">
                            <button class="option-icon-padding btn">
                              <i class="icon-files-empty icon-1x"/>
                            </button>
                          </div>
                        </div>
                    </div>
                </template>
                <template v-slot:clientCd="slotData">
                    <router-link :to="{path:'/template/management/events/detail',query:{eventId:slotData.data.eventId}}">
                        {{slotData.data.clientCd | changeOptionsValueToText(clientCdOptions)}}
                    </router-link>
                </template>
                <template v-slot:routeLink="slotData">
                    <router-link :to="{path:'/template/management/events/detail',query:{eventId:slotData.data.eventId}}"><div>{{slotData.data[slotData.field]}}</div></router-link>
                </template>
            </basic-table>
        </div>
        <event-type-modal :target="eventTypeModal" v-model="eventInfo" :ref="eventTypeModal"/>
        <bulk-send-modal :target="bulkSendModal" :eventInfo="eventInfo" :ref="bulkSendModal"/>
        <event-type-modal :target="copyEventModal" is-copy :ref="copyEventModal"/>
    </div>
</template>

<script>
    import BasicTable from "@/components/form/table/BasicTable";
    import BlockTarget from "@/components/block/BlockTarget";
    import Select2 from "@/components/form/select/Select2";
    import InputSearch from "@/components/form/input/InputSearch";
    import Paging from "@/components/pagination/Paging";
    import api from '@/api/template'
    import EventTypeModal from "@/components/modal/EventTypeModal";
    import BulkSendModal from "@/components/modal/BulkSendModal";
    export default {
        name: "EventTypeMng",
        components:{
            BulkSendModal,
            EventTypeModal,
            BlockTarget,
            Select2,
            InputSearch,
            Paging,
            BasicTable
        },
        data() {
            return {
                bulkSendModal: 'bulkSendModal',
                eventTypeModal:'eventTypeModal',
                copyEventModal: 'copyEventModal',
                eventInfo: {
                    clientCd:'lnbbt',
                    name:'',
                    typeCd:''
                },
                params:{
                    clientCd:'',
                    cateCd:'',
                    searchType: 'eventId',
                    searchText:'',
                    page:0,
                    order:'sysUpdDtm',
                    sort: 'desc'
                },
                eventListOrderOptions: [
                    {text: 'Event Id', value: 'eventId'},
                    {text: 'Update Date', value: 'sysUpdDtm'},
                ],
                tableFields:[
                    {key:'eventId',label:'Event Id',width:'10%',slot:'routeLink'},
                    {key:'eventNm',label:'Name',width:'35%',slot:'routeLink'},
                    {key:'clientCd',label:'Client Code',width:'25%',slot:'clientCd'},
                    {key:'notiCenterYn',label:'notiCenterYn',width:'10%',slot:'routeLink'},
                    {key:'usrYn',label:'UsrYn',width:'5%',slot:'routeLink'},
                    {key:'custYn',label:'CustYn',width:'5%',slot:'routeLink'},
                    {key:'paramCnt',label:'paramCnt',width:'5%',slot:'routeLink'},
                    {key:'paramSubjectCnt',label:'Max Parameter Subject',width:'5%',slot:'routeLink'},
                    {key:'icons',label:'',width:'5%',slot:'icons'},
                ],
                categoryOptions: [
                    {text: 'Normal', value: '1'},
                    {text: 'Deposit', value: '2'},
                    {text: 'Withdraw', value: '3'},
                    {text: 'Debit Card', value: '4'},
                    {text: 'Term Account', value: '5'},
                    {text: 'KTA', value: '6'},
                    {text: 'Quick Credit', value: '7'},
                ],
                searchTypeOptions: [
                    {text: 'Event Id', value: 'eventId'},
                    {text: 'Keyword', value: 'keyword'},
                ],
                pageInfo:{
                    pages:[1],
                    page:1,
                },
                events: []
            }
        },
        mounted() {
            if(this.legacyParams) this.params = this.legacyParams
            this.search()
        },
        computed: {
            clientCdOptions: function() {
                return this.$store.getters[this.$const.GETTERS.CLIENT_CD_OPTIONS]()
            },
            legacyParams: function() {
                return this.$store.getters[this.$const.GETTERS.GET_LEGACY_PARAMS]()[this.$route.name]
            }
        },
        methods: {
            search:function(page) {
                typeof page !== 'undefined' ? this.params.page = page : this.params.page = 0
                this.$refs.blockTarget.block()
                api.getEvents(this.params).then((res) => {
                    let response = this.resObj(res,true)
                    this.events = response.content
                    this.pageInfo = response.pageInfo
                }).finally(()=> {
                    this.$refs.blockTarget.unblock()
                })
            },
            setEventModalOptions: function(data, isCopy) {
                if(data.type === 'click') {
                    // create
                    this.$refs.eventTypeModal.setEventTypeData({clientCd: 'hobis',eventNm:'',eventId: '',usrYn: 'Y',custYn: 'Y',notiCenterYn:'Y',notiCateCd:'',notiTypeCd:'0',queueType :'R', addParamSubjYn: 'N'},true)
                } else {
                    if(isCopy) {
                        // copy
                        this.$refs.copyEventModal.setEventTypeData(data,true)
                    } else {
                        // edit
                        this.$refs.eventTypeModal.setEventTypeData(data, false)
                    }
                }
            },
            deleteEvent: function(item) {
                this.$notify.warningConfirm(item.eventId,()=> {
                    api.deleteEvent(item.eventId).then((result)=>{
                        if(result && result.data.code === 1000) {
                            this.$notify.success('Success')
                            this.search()
                        } else {
                            this.$notify.alert(result.data.message)
                        }
                    })
                })
            },
            changeSort: function(sort) {
                this.params.sort = sort
                this.search()
            }
        },
        watch: {
            'params.order': function(val) {
                this.search()
            }
        },
        beforeRouteLeave (to, from, next) {
            this.$store.commit(this.$const.MUTATE.SET_LEGACY_PARAMS,{name:from.name,params:this.params})
            next()
        },
    }
</script>

<style scoped>

</style>
